/**
 * TraceIdManager - Manages a traceId per tab session (sessionStorage), not an APM trace id. It survives reloads and
 * sign-outs, so it links one tab's page loads (`pageLoadId`). A tab opened from this one with `window.open` starts
 * with a copy of it.
 */
class TraceIdManager {
  private traceId = '';
  private storageKey = 'app_trace_id';

  constructor() {
    this.restoreFromStorage();
  }

  /**
   * Attempts to restore the traceId from sessionStorage
   * This is useful after page refreshes
   */
  restoreFromStorage() {
    const storedTraceId = sessionStorage.getItem(this.storageKey);
    if (storedTraceId) {
      this.traceId = storedTraceId;
    }
  }

  generateTraceId(): string {
    return crypto.randomUUID();
  }

  getTraceId() {
    if (this.traceId) {
      return this.traceId;
    }

    this.traceId = this.generateTraceId();
    sessionStorage.setItem(this.storageKey, this.traceId);
    return this.traceId;
  }
}

// Create a singleton instance
export const traceIdManager = new TraceIdManager();
